import { useState, useEffect, useRef } from "react";
import EventHandlersThrottler from "util/EventHandlersThrottler";
const useGraphWidth = (initialWidth = 600) => {
  const eventThrottler = useRef(new EventHandlersThrottler());
  const graphContainerRef = useRef(null);
  const [graphWidth, setGraphWidth] = useState(initialWidth);
  useEffect(() => {
    const resizeGraphs = () => {
      var _a;
      const { clientWidth } = (_a = graphContainerRef == null ? void 0 : graphContainerRef.current) != null ? _a : initialWidth;
      setGraphWidth(clientWidth);
    };
    const onResize = () => {
      eventThrottler.current.throttle(() => resizeGraphs());
    };
    resizeGraphs();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [initialWidth]);
  return { graphWidth, graphContainerRef };
};
export default useGraphWidth;
